export const getPersonas = () => {
    return [
        {
            name: "Плаксина Тамара Ивановна",
            paragraphs: [
                "Основатель межкафедральной учебно-научной лаборатории «Гербарий-SV»",
                "Научная степень, звание: доктор биологических наук, профессор, почетный профессор Самарского государственного университета",
                "Образование:",
                "1954–1959 – обучение в Куйбышевском государственном педагогическом институте",
                "1965–1968 – целевая аспирантура на кафедре органической и биоорганической химии Московского государственного педагогического института им. В. И. Ленина",
                "1970 – защита кандидатской диссертации «Биохимическая характеристика листьев шелковицы различной степени плоидности»",
                "1994 – защита докторской диссертации «Флора Волго-Уральского региона»",
                "1995 – присвоено ученое звание «Профессор»",
                "Научные интересы: флора и флорогенез Восточной Европы, растительные ресурсы, охрана и мониторинг природных территорий Волго-Уральского региона, охрана и мониторинг мест произрастания редких и исчезающих растений",
                "Работа в гербарии: собрала и обработала более 20 тысяч гербарных листов, образцы хранятся в Гербариях LE, MW, MHA, PVB, SMR, ZHR, Самарского областного историко-краеведческого музея",
                "Научные труды: автор около 500 научных публикаций, 15 монографий, 19 учебных пособий",
                "Прочее:",
                "Член-корреспондент Российской академии естественных наук (2006)",
                "Член Русского ботанического общества и его отделений в г. Самаре и г. Тольятти (1963)",
                "Член диссертационных советов по присуждению ученых степеней при Самарском государственном университете по специальности «экология» и при Оренбургском государственном педагогическом университете по специальности «ботаника»",
                "Почетный работник высшего профессионального образования России (1999)",
                "Участник международного проекта Atlas Florae Europaeae (1983, 1986, 1989)",
                "Эксперт и соавтор Красных книг СССР (1984), РСФСР (1988), Российской Федерации (2008), Самарской области (2007, 2017), Оренбургской области (2019)",
                "Обладатель авторского свидетельства «Способ получения олеаноловой кислоты»"
            ],
            img: "pla.jpg"
        },
        {
            name: "Прохорова Наталья Владимировна",
            paragraphs: [
                "Должность: профессор кафедры экологии, ботаники и охраны природы Самарского университета",
                "Научная степень, звание: доктор биологических наук, профессор",
                "Образование:",
                "1974–1979 – обучение в Куйбышевском государственном университете",
                "1996 – защита кандидатской диссертации «Распределение тяжелых металлов в почвах и растениях в зависимости от экологических особенностей лесостепного и степного Поволжья»",
                "1999 – присвоено ученое звание «Доцент»",
                "2006 – защита докторской диссертации «Экологические принципы биогеохимического анализа ландшафтов лесостепного и степного Поволжья»",
                "2009 – присвоено ученое звание «Профессор»",
                "Научные интересы: экология, урбоэкология, экологическая геохимия почв и биогеохимия растений, проблемы сохранения биологического разнообразия",
                "Работа в гербарии: научный руководитель межкафедральной учебно-научной лаборатории «Гербарий-SV»",
                "Научные труды: автор более 350 научных публикаций, соавтор 10 коллективных монографий. Список основных публикаций: " + `<a target='_blank' href="https://ssau.ru/staff/401575-prokhorova-natalya-vladimirovna/publ">Открыть в новой вкладке</a>`,
                "Контакты: e-mail: natali.prokhorova.55@mail.ru, prokhorova.nv@ssau.ru"
            ],
            img: "pro.jpg"
        },
        {
            name: "Макарова Юлия Владимировна",
            paragraphs: [
                "Должность: доцент кафедры экологии, ботаники и охраны природы Самарского университета",
                "Научная степень, звание: кандидат биологических наук",
                "Образование:",
                "1995–2000 – обучение в Самарском государственном университете",
                "2006 – защита кандидатской диссертации «Гистохимическая оценка накопления и распределения тяжелых металлов в органах и тканях сельскохозяйственных растений в зависимости от условий произрастания»",
                "Научные интересы: биогеохимия, флористика, гербарное дело",
                "Работа в гербарии: куратор гербарного фонда, определение растений, монтировка, чистовое этикетирование и инсерирование гербарных образцов",
                "Научные труды: список основных публикаций: " + `<a target='_blank' href="https://ssau.ru/staff/371023-makarova-yuliya-vladimirovna/publ">Открыть в новой вкладке</a>`,
                "Контакты: e-mail: makarova.yuv@ssau.ru",
            ],
            img: "mak.jpg"
        },
        {
            name: "Корчиков Евгений Сергеевич",
            paragraphs: [
                "Должность: доцент кафедры экологии, ботаники и охраны природы Самарского университета",
                "Научная степень, звание: кандидат биологических наук",
                "Образование:",
                "2001–2006 – обучение в Самарском государственном университете",
                "2010 – защита кандидатской диссертации «Биоэкологическая характеристика лишайников пространственно изолированных территорий (на примере Самарской Луки и Красносамарского лесного массива в Самарской области)»",
                "Научные интересы: экология и разнообразие лишайников, сосудистых растений, мохообразных и некоторых грибов Самарской области; ценопопуляционные и фитоценологические исследования; экологическая оценка антропогенно нарушенных территорий; продуктивность растений; химический состав лишайников, лекарственных растений, плодов и ягод семечковых и косточковых культур при произрастании в условиях Самарской области",
                "Работа в гербарии: куратор коллекции лишайников и грибов",
                "Научные труды: автор 145 печатных работ, из них 3 монографии, 4 учебных пособия. Список основных публикаций: " + `<a target='_blank' href="https://ssau.ru/staff/368645-korchikov-evgeniy-sergeevich/publ">Открыть в новой вкладке</a>`,
                "Прочее: ответственный редактор журнала «Вестник молодых ученых и специалистов Самарского университета»",
                "Контакты: e-mail: evkor@inbox.ru",
            ],
            img: "krE.jpg"
        },
        {
            name: "Кузовенко Оксана Анатольевна",
            paragraphs: [
                "Должность: доцент кафедры экологии, ботаники и охраны природы Самарского университета",
                "Научная степень, звание: кандидат биологических наук",
                "Образование:",
                "1995–2000 – обучение в Самарском государственном университете",
                "2004 – защита кандидатской диссертации «Флора Общего Сырта в Самаро-Уральском междуречье»",
                "Научные интересы: степная флора, флора особо охраняемых природных территорий Самарской и Оренбургской областей",
                "Работа в гербарии: определение растений, монтировка, чистовое этикетирование гербарных образцов",
                "Научные труды: список основных публикаций: " + `<a target='_blank' href="https://ssau.ru/staff/368810-kuzovenko-oksana-anatolevna/publ">Открыть в новой вкладке</a>`,
                "Контакты: e-mail: fragaria88@mail.ru/staff/368810-kuzovenko-oksana-anatolevna/publ",
            ],
            img: "kuz.jpg"
        },
        {
            name: "Калашникова Ольга Владимировна",
            paragraphs: [
                "Должность: начальник отдела конгрессно-выставочной деятельности Самарского университета",
                "Научная степень, звание: кандидат биологических наук",
                "Образование",
                "2002–2007 – обучение в Самарском государственном университете",
                "2011 – защита кандидатской диссертации «Флора сосудистых растений провинции Приволжской возвышенности Самарской области»",
                "Научные интересы: научно-исследовательская и природоохранная деятельность. Флора и растительность Приволжской возвышенности Самарской области, лесные массивы и водные объекты Волго-Уральского региона, особо охраняемые природные территории, раритетные виды флоры и их охрана",
                "Работа в гербарии: определение растений",
                "Научные труды: список основных публикаций: " + `<a target='_blank' href="https://ssau.ru/staff/20130508-kalashnikova-olga-vladimirovna/publ">Открыть в новой вкладке</a>`,
                "Прочее:",
                "2007 – член Самарского отделения Русского ботанического общества",
                "2009 – член-корреспондент Самарской общественной гуманитарно-эстетической академии",
                "2015 – член Самарского отделения Русского географического общества",
                "2017 – член-корреспондент регионального отделения Российской экологической академии",
                "2019 – почетное ученое звание «основатель научного направления»",
                "Контакты: e-mail: kalashnikova.samara@mail.ru",
            ],
            img: "kls.jpg"
        },
        {
            name: "Богданова Яна Андреевна",
            paragraphs: [
                "Должность: ассистент кафедры экологии, ботаники и охраны природы Самарского университета",
                "Образование:",
                "2009–2014 – обучение в Самарском государственном университете",
                "2014–2018 – обучение в аспирантуре Самарского национального исследовательского университета имени академика С. П. Королева",
                "Научные интересы: бриология, бриоиндикация, экологический мониторинг",
                "Работа в гербарии: куратор коллекции мхов",
                "Научные труды: cписок основных публикаций: " + `<a target='_blank' href="https://ssau.ru/staff/229878080-bogdanova-yana-andreevna/publ">Открыть в новой вкладке</a>`,
                "Контакты: e-mail: bogdanova.ya@yandex.ru",
            ],
            img: "bgd.jpg"
        },
        {
            name: "Корчикова Татьяна Александровна",
            paragraphs: [
                "Должность: учебный мастер второй категории кафедры экологии, ботаники и охраны природы Самарского университета",
                "Образование:",
                "2002–2007 – обучение в Самарском государственном университете",
                "2007–2010 – обучение в аспирантуре Самарского государственного университета. Тема диссертации – «Флора бассейна реки Большого Кинеля в пределах Самарского Заволжья»",
                "Научные интересы: флора Высокого Заволжья, особо охраняемые природные территории",
                "Работа в гербарии: организационная работа, монтировка гербария, определение растений, чистовое этикетирование, внесение данных в базу цифрового гербария",
                "Научные труды: список основных публикаций: " + `<a target='_blank' href="https://ssau.ru/staff/60325328-korchikova-tatyana-aleksandrovna/publ">Открыть в новой вкладке</a>`,
                "Контакты: e-mail: listochek5@yandex.ru",
            ],
            img: "krT.jpg"
        },
        {
            name: "Рязанова Яна Анатольевна",
            paragraphs: [
                "Должность: аспирант кафедры экологии, ботаники и охраны природы Самарского университета",
                "Образование:",
                "2017–2022 – обучение в Самарском национальном исследовательском университете имени академика С. П. Королева",
                "С 2022 – обучение в аспирантуре Самарского национального исследовательского университета имени академика С. П. Королева. Тема диссертации – «Эколого-флористическое разнообразие и биогеохимические особенности ООПТ южных районов Самарской области»",
                "Научные интересы: степная флора, флора особо охраняемых природных территорий",
                "Работа в гербарии: чистовое оформление и монтировка гербарных образцов, участие в последующем формировании гербарного фонда",
                "Научные труды: список основных публикаций: автор более 15 печатных работ",
                "Контакты: e-mail: samotueva99@mail.ru"
            ],
            img: "rya.jpeg"
        }
    ]
}